function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { usd } from "./territory-common";

/*
 * Account lens control + banner (SALES_ACCOUNT_FILTER.md), shared by the Territory
 * overview and the territory/rep detail pages. Exclude and Isolate keep INDEPENDENT
 * selections — switching modes swaps to that mode's checked set. The parent owns
 * persistence (URL + localStorage) and reload; this component is presentational and
 * calls onApply(mode, ids) on Apply. `customers` is the UNFILTERED roster (picker
 * source + banner magnitude).
 */
export class AccountFilterControl extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      open: false,
      search: "",
      draftMode: "exclude",
      draftExcludeIds: [],
      draftIsolateIds: []
    });
    _defineProperty(this, "openPicker", () => this.setState({
      open: true,
      search: "",
      draftMode: this.props.mode || "exclude",
      draftExcludeIds: (this.props.mode || "exclude") === "exclude" ? [...(this.props.ids || [])] : [],
      draftIsolateIds: this.props.mode === "isolate" ? [...(this.props.ids || [])] : []
    }));
    _defineProperty(this, "draftKey", () => this.state.draftMode === "isolate" ? "draftIsolateIds" : "draftExcludeIds");
    _defineProperty(this, "draftIds", () => this.state[this.draftKey()]);
    _defineProperty(this, "toggleDraft", id => {
      id = String(id);
      const key = this.draftKey();
      const set = new Set(this.state[key].map(String));
      if (set.has(id)) set.delete(id);else set.add(id);
      this.setState({
        [key]: [...set]
      });
    });
    _defineProperty(this, "apply", () => {
      this.setState({
        open: false
      });
      this.props.onApply(this.state.draftMode, this.draftIds());
    });
  }
  render() {
    const {
      customers = [],
      mode,
      ids = []
    } = this.props;
    // Hidden when there are no B2B accounts to pick from (e.g. a retail-only workspace), unless a
    // lens is already applied, so it can still be cleared.
    if (!customers.length && !ids.length) return null;
    const {
      open,
      search,
      draftMode
    } = this.state;
    const draftIds = this.draftIds();
    const total = customers.reduce((a, c) => a + (Number(c.totalAmount) || 0), 0) || 1;
    const q = (search || "").trim().toLowerCase();
    const rows = q ? customers.filter(c => `${c.name || ""} ${c.accountNumber || ""}`.toLowerCase().includes(q)) : customers;
    const accent = draftMode === "isolate" ? "#2f7fd1" : "#ff6358";
    const chipBg = ids.length ? mode === "isolate" ? {
      background: "#eaf4ff",
      borderColor: "#cfe3f8",
      color: "#215a9b",
      fontWeight: 700
    } : {
      background: "#fff1f0",
      borderColor: "#f6d3cf",
      color: "#b23b32",
      fontWeight: 700
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        height: 34,
        marginTop: 0,
        ...chipBg
      },
      onClick: () => open ? this.setState({
        open: false
      }) : this.openPicker()
    }, "\u2691 Accounts", ids.length ? ` (${ids.length})` : "", " \u25BE"), open && /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        zIndex: 40,
        top: 40,
        right: 0,
        width: 420,
        background: "#fff",
        border: "1px solid #e4e7ec",
        borderRadius: 12,
        boxShadow: "0 10px 30px rgba(20,26,38,.14)",
        overflow: "hidden"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        padding: "10px 12px",
        borderBottom: "1px solid #eceff3"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "inline-flex",
        border: "1px solid #e4e7ec",
        borderRadius: 7,
        overflow: "hidden",
        height: 30
      }
    }, [["exclude", "Exclude"], ["isolate", "Isolate"]].map(([m, l]) => /*#__PURE__*/React.createElement("span", {
      key: m,
      onClick: () => this.setState({
        draftMode: m
      }),
      style: {
        padding: "0 12px",
        display: "flex",
        alignItems: "center",
        fontSize: "12.5px",
        cursor: "pointer",
        background: draftMode === m ? accent : "#fff",
        color: draftMode === m ? "#fff" : "#3b424c"
      }
    }, l))), /*#__PURE__*/React.createElement("input", {
      autoFocus: true,
      value: search,
      onChange: e => this.setState({
        search: e.target.value
      }),
      placeholder: "Search accounts\u2026",
      style: {
        flex: 1,
        height: 30,
        margin: 0,
        boxSizing: "border-box",
        border: "1px solid #d5dbe3",
        borderRadius: 6,
        padding: "0 10px",
        fontSize: "12.5px"
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        maxHeight: 240,
        overflowY: "auto"
      }
    }, rows.length === 0 ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        padding: "10px 12px",
        margin: 0
      }
    }, "No accounts match.") : rows.slice(0, 80).map(c => {
      const id = String(c.accountNumber);
      const sel = draftIds.map(String).includes(id);
      const pct = Math.round((Number(c.totalAmount) || 0) / total * 100);
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        onClick: () => this.toggleDraft(id),
        style: {
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 12px",
          borderBottom: "1px solid #f2f4f7",
          cursor: "pointer",
          fontSize: 13
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          width: 16,
          height: 16,
          borderRadius: 4,
          border: "1.5px solid " + (sel ? accent : "#c4ccd6"),
          background: sel ? accent : "#fff",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          flex: "0 0 auto"
        }
      }, sel ? "✓" : ""), /*#__PURE__*/React.createElement("span", {
        style: {
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, c.name || id), /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#5b636e",
          whiteSpace: "nowrap",
          fontVariantNumeric: "tabular-nums"
        }
      }, usd(c.totalAmount)), /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#98a0ab",
          width: 44,
          textAlign: "right",
          fontVariantNumeric: "tabular-nums"
        }
      }, pct, "%"));
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 12px",
        borderTop: "1px solid #eceff3",
        fontSize: 12,
        color: "#98a0ab"
      }
    }, /*#__PURE__*/React.createElement("span", null, draftIds.length, " selected \xB7 ", draftMode === "isolate" ? "isolate" : "exclude"), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto",
        display: "inline-flex",
        gap: 8
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      style: {
        height: 32,
        minWidth: 72
      },
      onClick: () => this.setState({
        [this.draftKey()]: []
      })
    }, "Clear"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      style: {
        height: 32,
        minWidth: 72
      },
      onClick: this.apply
    }, "Apply")))));
  }
}
export function AccountFilterBanner({
  customers = [],
  mode,
  ids = [],
  onRemove,
  onClear
}) {
  if (!ids.length) return null;
  const idset = new Set(ids.map(String));
  const sel = customers.filter(c => idset.has(String(c.accountNumber)));
  const total = customers.reduce((a, c) => a + (Number(c.totalAmount) || 0), 0);
  const selSum = sel.reduce((a, c) => a + (Number(c.totalAmount) || 0), 0);
  const pct = total > 0 ? Math.round(selSum / total * 100) : 0;
  const iso = mode === "isolate";
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      flexWrap: "wrap",
      background: iso ? "#f2f8ff" : "#fff6f5",
      border: "1px solid " + (iso ? "#cfe3f8" : "#f6d3cf"),
      borderLeft: "3px solid " + (iso ? "#2f7fd1" : "#ff6358"),
      borderRadius: 10,
      padding: "10px 14px",
      margin: "0 0 12px",
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("span", null, "\u2691 ", /*#__PURE__*/React.createElement("b", null, iso ? "Isolating" : "Excluding", " ", ids.length, " account", ids.length > 1 ? "s" : ""), " \u2014 ", /*#__PURE__*/React.createElement("b", null, usd(selSum), iso ? "" : " of " + usd(total), " (", pct, "%)"), " ", iso ? "of the book" : "removed", "."), sel.map(c => /*#__PURE__*/React.createElement("span", {
    key: String(c.accountNumber),
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      background: "#fff",
      border: "1px solid " + (iso ? "#cfe3f8" : "#f6d3cf"),
      color: iso ? "#215a9b" : "#b23b32",
      borderRadius: 14,
      padding: "3px 6px 3px 10px",
      fontSize: 12,
      fontWeight: 600
    }
  }, c.name || c.accountNumber, /*#__PURE__*/React.createElement("span", {
    onClick: () => onRemove(c.accountNumber),
    style: {
      cursor: "pointer",
      width: 15,
      height: 15,
      borderRadius: "50%",
      background: "rgba(0,0,0,.08)",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 10
    }
  }, "\u2715"))), sel.length < ids.length ? /*#__PURE__*/React.createElement("span", {
    className: "territory-hint",
    style: {
      margin: 0
    }
  }, "+", ids.length - sel.length, " more") : null, /*#__PURE__*/React.createElement("span", {
    onClick: onClear,
    style: {
      marginLeft: "auto",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "12.5px",
      color: iso ? "#215a9b" : "#b23b32"
    }
  }, "Clear"));
}